export default "__VITE_ASSET__0gQz9IuU__"